import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

interface EditStoreParams {
	id: number;
	payload: Record<string, unknown>;
}

const editStore = async ({ id, payload }: EditStoreParams) => {
	const response = await cmsClient.put(
		`/homepage/admin/store/store/${id}/`,
		payload
	);

	return response.data;
};

const useEditStore = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Store updated" />, {
			hideProgressBar: true
		});
	};

	const onError = (error: unknown) => {
		const detail = (error as any)?.response?.data;
		const message =
			detail?.detail ??
			(detail ? Object.values(detail).flat().join(" ") : null) ??
			"Something went wrong, try again";
		const safeMessage =
			message.length > 200 ? message.slice(0, 200) + "..." : message;

		toast.error(<CustomToast type="Error" message={safeMessage} />, {
			hideProgressBar: true
		});
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["admin-stores"]);
	};

	return useMutation(editStore, { onSuccess, onError, onSettled });
};

export default useEditStore;
